import type { TFullCommunityApi } from '@/src/features/community/api/communityApi.types'

export const VIRTUS_TAG_SLUG = 'virtus'

export const isVirtusCommunity = (community?: Pick<TFullCommunityApi, 'tags'>): boolean =>
  community?.tags.some((tag) => tag.slug === VIRTUS_TAG_SLUG) ?? false
